import { NavigationListenerDataType } from "@WahooFitness/wahoo-offline-mfe";

/**
 * This function is used to transform links from the settings mfe to the appropriate routes in the app.
 * @param path The path of the wahoo link e.g. /plans
 * @param params The query params of the wahoo link
 * @returns A NavigationListenerDataType object or undefined if no matching route is found
 */
export function wahooLinkTransform(
  path: string,
  params: URLSearchParams
): NavigationListenerDataType | undefined {
  const [_empty, resource, _resourceId] = path.split("/");
  switch (resource) {
    case "fitness_profiles":
      if (params.get("workout_type_family_id")) {
        // TODO: handle the workout type family id when we have multiple profiles
        return {
          url: `/fitness-profile?workout_type_family_id=${params.get("workout_type_family_id")}`,
        };
      }
      return { url: "/fitness-profile" };
    case "fitness_profile_algorithms":
      return { url: "/fourdp" };
    case "subscription_settings":
      return { url: "/membership" };
    default:
      return undefined;
  }
}
